import React from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useCatalog } from '../context/CatalogContext';
import { useLang } from '../context/LangContext';
import ProductDetailContent from '../components/ProductDetailContent';
import Sheet from '../lib/ui/Sheet';
import { EmptyState } from '../lib/ui/Feedback';

/** Rendered on top of a background location (product opened from Home/Categories/Cart). */
export default function ProductDetailOverlay() {
  const { id } = useParams();
  const { products } = useCatalog();
  const { lang } = useLang();
  const te = lang === 'te';
  const navigate = useNavigate();
  const product = products.find((p) => String(p.id) === String(id));
  const close = () => navigate(-1);

  return (
    <Sheet open onClose={close} maxWidth={640} labelledBy="pdp-title">
      <div className="relative">
        <button
          type="button"
          onClick={close}
          aria-label="Close"
          className="absolute top-3 right-3 z-10 h-9 w-9 rounded-full bg-white/90 shadow-soft font-black text-ink flex items-center justify-center"
        >
          ✕
        </button>
        {product ? (
          <ProductDetailContent product={product} />
        ) : (
          <div className="pt-10 pb-10"><EmptyState icon="🔍" title={te ? 'ఉత్పత్తి కనబడలేదు' : 'Product not found'} /></div>
        )}
      </div>
    </Sheet>
  );
}
